import { createTheme } from '@mui/material'
import typography from './typography'

export const theme = createTheme({
  palette: {
    background: {
      default: '#FFFFFF',
      paper: '#F2F3F4'
    },
    primary: {
      light: '#ECF8F0', // Emerald - Green primary - 10
      main: '#42BE65', // Emerald - Green primary
      dark: '#42BE65', // Emerald - Green primary
      contrastText: '#FFFFFF'
    },
    secondary: {
      light: '#808DA0', // Oxford blue - 50
      main: '#021B41', // Oxford blue
      dark: '#354967', // Oxford blue - 80
      contrastText: '#FFFFFF'
    },
    success: {
      main: '#021B41', // Oxford blue
    },
    error: {
      main: '#E5352B',
      contrastText: '#FFFFFF'
    },
    text: {
      primary: '#354967', // Oxford blue - 80
      secondary: '#42BE65', // White
      disabled: '#808DA0', // Oxford blue - 50
    },
  },
  typography,
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px inhe inset',
          },
        },
      },
    },
  },
})
